import React, { useState } from 'react'
import './onboarding-ios.scss'
import GenericModal from '../generic-modal/generic-modal'
import Button from '../../atoms/button/button'
import Slider from "react-slick";

const OnBoardingIOS = props => {

  const { setCommondModal } = props

  const [onBoardingStep, setOnBoardingStep] = useState(1)

  const closeModal = () => {
    var body = document.getElementsByTagName("body")[0];
    var html = document.getElementsByTagName("html")[0];
    body.classList.remove("overflow-body-hidden");
    html.classList.remove("overflow-body-hidden");

    deniedOnBoarding()
    setCommondModal(null)
  }

  const deniedOnBoarding = () => {
    localStorage.setItem('DENIED_ONBOARDING', 'true');
  }

  const settings = {
    slidesToShow: 1,
    dots: false,
    slidesToScroll: 1,
    infinite: false,
    vertical: false,
    speed: 500
  };

  return (
    <>
      {onBoardingStep === 1 && (
        <GenericModal>
          <span
            onClick={(e) => { e.preventDefault(); closeModal() }}
            className="icon2-close f-close-icon"
          />
          <div className="f-onboarding-ios-container">
            <span className="f-onboarding-ios-title">¿Quieres llevar el contenido de</span>
            <span className="f-onboarding-ios-subtitle">NOSOTRAS EN TU CELULAR?</span>
            <p className="f-onboarding-ios-description">
              Agrega el sitio de nosotras como un acceso directo en tu celular, solo sigue estos pasos.
            </p>
            <Button
              className="primary-pink"
              title="Continuar"
              onClick={(e) => { e.preventDefault(); setOnBoardingStep(2) }}
            />
            <span className="f-alter-button" onClick={(e) => { e.preventDefault(); closeModal() }}>
              Por ahora no
            </span>

          </div>
        </GenericModal>
      )}
      {onBoardingStep === 2 && (

        <div className='f-carousel-screenshot-container'>

          <Slider {...settings} className='f-carousel-screenshot-slider'>

            <div className="f-item-step">
              <span
                className="icon2-close f-close-icon"
                onClick={(e) => { e.preventDefault(); closeModal() }} />
              <div className="f-item-step-container">
                <div className="f-item-step-container-image">
                  <h2>Paso 1 de 3</h2>
                  <img
                    src={require('../../../assets/images/onBoarding/step-1.png')}
                    alt='Instalación PWA IOS' />
                </div>
                <div className="f-item-step-container-title">
                  <p><b>1. </b>Busca la opción de compartir</p>
                </div>
              </div>
            </div>

            <div className="f-item-step">
              <span
                className="icon2-close f-close-icon"
                onClick={(e) => { e.preventDefault(); closeModal() }} />
              <div className="f-item-step-container">
                <div className="f-item-step-container-image">
                  <h2>Paso 2 de 3</h2>
                  <img
                    className='f-item-step-container-image-ultra-small'
                    src={require('../../../assets/images/onBoarding/step-2.png')}
                    alt='Instalación PWA IOS' />
                </div>
                <div className="f-item-step-container-title">
                  <p><b>2. </b>Elige "Agregar a inicio"</p>
                </div>
              </div>
            </div>

            <div className="f-item-step">
              <span
                className="icon2-close f-close-icon"
                onClick={(e) => { e.preventDefault(); closeModal() }} />
              <div className="f-item-step-container">
                <div className="f-item-step-container-image">
                  <h2>Paso 3 de 3</h2>
                  <img
                    className='f-item-step-container-image-small'
                    src={require('../../../assets/images/onBoarding/step-3.png')}
                    alt='Instalación PWA IOS' />
                </div>
                <div className="f-item-step-container-title">
                  <p><b>3. </b>Selecciona "Agregar"</p>
                </div>
              </div>
            </div>

            <div className="f-carousel-screenshot-step-message">
              <div className="f-carousel-screenshot-step-message-container">
                <span
                  onClick={(e) => { e.preventDefault(); closeModal() }}
                  className="icon2-close f-close-icon"
                />
                <h2>¡Ahora te toca a ti!</h2>
                <p>
                  Sigue los pasos que acabas de ver y
                  lleva a NosotrasOnline en tu celular.
                  <br />
                  <br />
                  No te preocupes, no ocupará espacio en tu celular.
                  <br />
                  <br />
                  <br />
                </p>
              </div>
            </div>

          </Slider>

        </div>
      )}
    </>

  )
}

export default OnBoardingIOS
